import React from "react";
import "./About.css";

function About() {
    return (
    <div className="about-us-container">
        <div className="about-section">
          <h1>A FEW WORDS</h1>
          <h2>ABOUT US</h2>
          <p>
            For nearly 20 years, residents throughout the local area have turned to Car Repair for all of their automotive repair needs. With free estimates and fast turnaround, we are known for our personal service and expertise in all forms of specialized engine repair. We use the latest and most modern diagnostic technology to have you back in your car.
          </p>
          <button className="btn">READ MORE</button>
        </div>
    </div>
    );
} 
export default About;